module.exports = __webpack_public_path__ + "assets/img/next_task_ico.svg";